import { RequiredTranslationsTemplate } from '.'

const nl: RequiredTranslationsTemplate = {
  meta: {
    localeName: 'Nederlands',
  },
  home: {
    title: 'PRODUCT RECALL - ROCKRIDER XC500S',
    description:
      'Dank u voor uw aankoop van een ROCKRIDER XC500S mountainbike (MTB). We hebben een mogelijk zwak punt in de voorvork geïdentificeerd. Alleen bepaalde fietsen zijn defect. Voer de 30 cijfers van uw fiets traceerbaarheidsnummer in om te bevestigen of uw fiets onder deze terugroepactie valt:',
    form: {
      title: 'Voer de volgende gegevens in:',
      fields: {
        serialNumber: '	Fiets traceerbaarheidsnummer',
        serialNumberFamily: 'N° série (début)',
        firstName: 'Voornaam',
        lastName: 'Achternaam',
        email: 'Email',
        phone: 'Telefoonnummer',
        country: 'Land',
        submit: 'Bevestigen',
        choose: 'Kies...',
      },
      errors: {
        requiredField: 'Dit veld is verplicht',
        unknownSerialNumber: 'Onbekend serienummer',
        provide6Numbers: '6 cijfers zijn vereist',
      },
      confirmations: {
        good: {
          title: 'Uw fiets wordt niet beïnvloed',
          p1: 'Houd er rekening mee dat uw fiets niet onder deze terugroepactie valt. Blijf vooral genieten van het fietsen.',
          p2: 'Onze excuses voor het ongemak,',
          p3: 'Hoogachtend,',
          p4: 'Het Decathlon-team',
        },
        defective: {
          title: 'Uw fiets is helaas getroffen.',
          p1: 'We vragen je om het gebruik van deze fiets onmiddellijk te stoppen en contact op te nemen met je dichtstbijzijnde Decathlon-winkel om de vork te laten vervangen.',
          p2: 'Houd er rekening mee dat u tijdens de reparatie mogelijk enkele dagen geen gebruik kunt maken van uw fiets. Wees gerust, we zullen ons uiterste best doen om deze vertragingen tot een minimum te beperken. We raden je aan om rechtstreeks contact op te nemen met de werkplaats van je geselecteerde Decathlon-winkel om een ​​inschatting te maken van de reparatietijd.',
          p3: 'Om de dichtstbijzijnde Decathlon Workshop te vinden, kijk op  :',
          decathlonLocatorLink: 'https://www.decathlon.fr/store-locator',
          p4: 'Hieronder vindt u uw "Klantretourmelding" om aan onze technicus te presenteren wanneer u terugkeert naar de werkplaats:',
          p5: 'Neem voor meer informatie contact op met onze klantenservice op het nummer 02 208 26 60 van maandag tot zaterdag van 9.00 tot 19.00uur klantendienst@decathlon.com',
        },
      },
    },
    findTheSerialNumber: {
      title: 'Waar vind je het traceerbaarheidsnummer van de fiets',
      description:
        'Het 30-cijferige nummer staat op de onderkant van uw fietsframe, dicht bij de trapas en pedalen. Zie onderstaande afbeelding.',
    },
  },
}

export default nl
